const sleep = (ms: any) => new Promise((r) => setTimeout(r, ms))

export default sleep